export default __webpack_public_path__ + "static/media/hht1_ep19_timeline_q03_a.df699b8f.png";